/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global THREE */

var scene = new THREE.Scene();
scene.background = new THREE.Color(0xffffff);

var camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.y = 2;

var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);

var controls = new THREE.OrbitControls(camera, renderer.domElement);
controls.enableZoom = true;

var raycaster = new THREE.Raycaster();

function loadScript(src) {

    console.log(src);
    return new Promise(function (resolve, reject) {

        var script = document.createElement('script');
        script.setAttribute('src', src);

        document.body.appendChild(script);

        script.addEventListener('load', function () {

            resolve();
        });

        script.addEventListener('error', function () {

            reject();
        });
    });
}

function numberToOppioite(num) {

    var newNum = void 0;

    if (num > 0) {

        newNum = -num;
    } else {

        newNum = Math.abs(num);
    }

    return newNum;
}

exports.scene = scene;
exports.camera = camera;
exports.renderer = renderer;
exports.controls = controls;
exports.loadScript = loadScript;
exports.raycaster = raycaster;
exports.numberToOppioite = numberToOppioite;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.controller2 = exports.controller1 = undefined;

var _basics = __webpack_require__(0);

var _render = __webpack_require__(2);

var _render2 = _interopRequireDefault(_render);

var _teleporting = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller1 = void 0,
    controller2 = void 0; /* global THREE */

function loadViveControllers() {

        exports.controller1 = controller1 = new THREE.ViveController(0);
        exports.controller2 = controller2 = new THREE.ViveController(1);

        controller1.standingMatrix = _basics.renderer.vr.getStandingMatrix();
        controller2.standingMatrix = _basics.renderer.vr.getStandingMatrix();

        _basics.scene.add(controller1);
        _basics.scene.add(controller2);

        var loader = new THREE.OBJLoader();
        loader.setPath('./controllerObject/');
        loader.load('vr_controller_vive_1_5.obj', function (object) {

                var textureLoader = new THREE.TextureLoader();
                textureLoader.setPath('./controllerObject/');

                var controller = object.children[0];
                controller.material.map = textureLoader.load('onepointfive_texture.png');
                controller.material.specularMap = textureLoader.load('onepointfive_spec.png');

                controller1.name = 'controller1';
                controller2.name = 'controller2';

                controller1.add(object.clone());
                controller2.add(object.clone());

                var lineGeometry1 = new THREE.Geometry(),
                    lineGeometry2 = new THREE.Geometry(),
                    material1 = new THREE.LineBasicMaterial({
                        color: 0x0000ff
                }),
                    material2 = new THREE.LineBasicMaterial({
                        color: 0x0000ff
                });

                lineGeometry1.vertices.push(new THREE.Vector3(0, 0, 0));
                lineGeometry1.vertices.push(new THREE.Vector3(0, 0, -1));

                lineGeometry2.vertices.push(new THREE.Vector3(0, 0, 0));
                lineGeometry2.vertices.push(new THREE.Vector3(0, 0, -1));

                // material.transparent = true
                // material.opacity = 1

                var line1 = new THREE.Line(lineGeometry1, material1),
                    line2 = new THREE.Line(lineGeometry2, material2);

                line1.name = 'raycasterLine';
                line1.scale.z = 5;

                line2.name = 'raycasterLine';
                line2.scale.z = 5;

                controller1.add(line1.clone());
                controller2.add(line2.clone());

                controller1.addEventListener('triggerdown', _teleporting.teleport);
                controller2.addEventListener('triggerdown', _teleporting.teleport);

                (0, _render2.default)();
        });
}

exports.default = loadViveControllers;
exports.controller1 = controller1;
exports.controller2 = controller2;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

var _WebVR = __webpack_require__(5);

var _WebVR2 = _interopRequireDefault(_WebVR);

var _basics = __webpack_require__(0);

var _loadViveControllers = __webpack_require__(1);

var _teleporting = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global THREE */

function animate() {

        _WebVR2.default.checkAvailability().then(function () {

                _basics.renderer.animate(VRrenderer);
        }).catch(function () {

                _basics.renderer.animate(render);
        });
}

function VRrenderer() {

        _loadViveControllers.controller1.update();
        _loadViveControllers.controller2.update();

        (0, _teleporting.rayIntersects)(_loadViveControllers.controller1).then(function () {

                _loadViveControllers.controller1.children[1].material.color = new THREE.Color(0x00ff85);
        }).catch(function () {

                _loadViveControllers.controller1.children[1].material.color = new THREE.Color(0x0000ff);
        });

        (0, _teleporting.rayIntersects)(_loadViveControllers.controller2).then(function () {

                _loadViveControllers.controller2.children[1].material.color = new THREE.Color(0x00ff85);
        }).catch(function () {

                _loadViveControllers.controller2.children[1].material.color = new THREE.Color(0x0000ff);
        });

        _basics.renderer.render(_basics.scene, _basics.camera);
}

function render() {

        _basics.renderer.render(_basics.scene, _basics.camera);
}

exports.default = animate;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _basics = __webpack_require__(0);

var _stats = __webpack_require__(4);

var _WebVR = __webpack_require__(5);

var _WebVR2 = _interopRequireDefault(_WebVR);

var _loadViveControllers = __webpack_require__(1);

var _loadViveControllers2 = _interopRequireDefault(_loadViveControllers);

var _maze = __webpack_require__(6);

var _maze2 = _interopRequireDefault(_maze);

var _render = __webpack_require__(2);

var _render2 = _interopRequireDefault(_render);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global THREE */

var light = new THREE.HemisphereLight(0xe4e4e4, 0x080820, 1);

var footing = void 0,
    geometry = void 0,
    material = void 0,
    box = void 0;

_basics.scene.add(_basics.camera);

function yourFooting() {

    geometry = new THREE.BoxGeometry(_maze2.default.tile[0] * 4, 1, _maze2.default.tile[1] * 4);
    material = new THREE.MeshPhongMaterial({ color: 0x6591b0, wireframe: false, shading: THREE.SmoothShading });
    footing = new THREE.Mesh(geometry, material);

    footing.translateX(0);
    footing.translateZ(0);
    footing.translateY(-0.5);
    footing.name = 'footing';
    _maze2.default.container.add(footing);
}

init();

function init() {

    _maze2.default.render();

    // base.container.translateY( 0.5 )
    // base.container.translateZ( -10 )
    console.log(_maze2.default.tile[0] / 2 - _maze2.default.mazeStart[0]);
    _maze2.default.container.translateX(Math.round(_maze2.default.tile[0] / 2 - _maze2.default.mazeStart[0]));
    _maze2.default.container.translateZ(-(_maze2.default.mazeStart[1] / 2) - 1);
    _maze2.default.container.rotation.x = Math.PI / 360 * 0;
    _maze2.default.container.rotation.z = Math.PI / 360 * 0;

    yourFooting();
    _maze2.default.container.add(_maze2.default.obj);
    _basics.scene.add(_maze2.default.container);

    geometry = new THREE.BoxGeometry(1, 1, 1);
    material = new THREE.MeshLambertMaterial({ color: 0x000000, wireframe: true });
    box = new THREE.Mesh(geometry, material);
    box.position.set(0, 10, 0);
    _basics.scene.add(box);
    light.position.set(0, 10, 0);
    _basics.scene.add(light);

    setLight([-20, 20, -30], 0xffffff, 0.5, _maze2.default.container, true);

    // VR
    _WebVR2.default.checkAvailability().then(function () {

        _WebVR2.default.getVRDisplay(function (display) {

            console.log(display);

            _basics.renderer.vr.enabled = true;
            _basics.renderer.vr.standing = true;
            _basics.renderer.vr.setDevice(display);

            document.body.appendChild(_WebVR2.default.getButton(display, _basics.renderer.domElement));

            if (display.displayName.includes('Vive')) {

                console.log('Vive');

                (0, _basics.loadScript)('ViveController.js').then(function () {

                    console.log('ViveController.js loaded');
                    (0, _loadViveControllers2.default)();
                }).catch(function () {

                    console.log('Could not load the script');
                });
            } else {

                (0, _render2.default)();
            }
        });
    }).catch(function (message) {

        console.log(message);
        (0, _render2.default)();
    });

    window.addEventListener('resize', onWindowResize, false);
}

function onWindowResize() {

    _basics.camera.aspect = window.innerWidth / window.innerHeight;
    _basics.camera.updateProjectionMatrix();

    _basics.renderer.setSize(window.innerWidth, window.innerHeight);
}

function setLight(pos, color, opacity, dest, targetBox) {

    var currLight = new THREE.DirectionalLight(color, opacity);
    currLight.position.set(pos[0], pos[1], pos[2]);

    dest.add(currLight);

    if (targetBox) {

        geometry = new THREE.BoxGeometry(1, 1, 1);
        material = new THREE.MeshPhongMaterial({ color: 0x000000, wireframe: true });
        var lightBox = new THREE.Mesh(geometry, material);
        lightBox.position.set(pos[0], pos[1], pos[2]);
        dest.add(lightBox);
    }
}

(0, _stats.statsInit)();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.statsInit = statsInit;
/**
 * @author mrdoob / http://mrdoob.com/
 */

var Stats = function Stats() {

	var mode = 0;

	var container = document.createElement('div');
	container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
	container.addEventListener('click', function (event) {

		event.preventDefault();
		showPanel(++mode % container.children.length);
	}, false);

	//

	function addPanel(panel) {

		container.appendChild(panel.dom);
		return panel;
	}

	function showPanel(id) {

		for (var i = 0; i < container.children.length; i++) {

			container.children[i].style.display = i === id ? 'block' : 'none';
		}

		mode = id;
	}

	//

	var beginTime = (performance || Date).now(),
	    prevTime = beginTime,
	    frames = 0;

	var fpsPanel = addPanel(new Stats.Panel('FPS', '#0ff', '#002'));
	var msPanel = addPanel(new Stats.Panel('MS', '#0f0', '#020'));

	if (self.performance && self.performance.memory) {

		var memPanel = addPanel(new Stats.Panel('MB', '#f08', '#201'));
	}

	showPanel(0);

	return {

		REVISION: 16,

		dom: container,

		addPanel: addPanel,
		showPanel: showPanel,

		begin: function begin() {

			beginTime = (performance || Date).now();
		},

		end: function end() {

			frames++;

			var time = (performance || Date).now();

			msPanel.update(time - beginTime, 200);

			if (time > prevTime + 1000) {

				fpsPanel.update(frames * 1000 / (time - prevTime), 100);

				prevTime = time;
				frames = 0;

				if (memPanel) {

					var memory = performance.memory;
					memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
				}
			}

			return time;
		},

		update: function update() {

			beginTime = this.end();
		},

		// Backwards Compatibility

		domElement: container,
		setMode: showPanel

	};
};

Stats.Panel = function (name, fg, bg) {

	var min = Infinity,
	    max = 0,
	    round = Math.round;
	var PR = round(window.devicePixelRatio || 1);

	var WIDTH = 80 * PR,
	    HEIGHT = 48 * PR,
	    TEXT_X = 3 * PR,
	    TEXT_Y = 2 * PR,
	    GRAPH_X = 3 * PR,
	    GRAPH_Y = 15 * PR,
	    GRAPH_WIDTH = 74 * PR,
	    GRAPH_HEIGHT = 30 * PR;

	var canvas = document.createElement('canvas');
	canvas.width = WIDTH;
	canvas.height = HEIGHT;
	canvas.style.cssText = 'width:80px;height:48px';

	var context = canvas.getContext('2d');
	context.font = 'bold ' + 9 * PR + 'px Helvetica,Arial,sans-serif';
	context.textBaseline = 'top';

	context.fillStyle = bg;
	context.fillRect(0, 0, WIDTH, HEIGHT);

	context.fillStyle = fg;
	context.fillText(name, TEXT_X, TEXT_Y);
	context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

	context.fillStyle = bg;
	context.globalAlpha = 0.9;
	context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

	return {

		dom: canvas,

		update: function update(value, maxValue) {

			min = Math.min(min, value);
			max = Math.max(max, value);

			context.fillStyle = bg;
			context.globalAlpha = 1;
			context.fillRect(0, 0, WIDTH, GRAPH_Y);
			context.fillStyle = fg;
			context.fillText(round(value) + ' ' + name + ' (' + round(min) + '-' + round(max) + ')', TEXT_X, TEXT_Y);

			context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);

			context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);

			context.fillStyle = bg;
			context.globalAlpha = 0.9;
			context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - value / maxValue) * GRAPH_HEIGHT));
		}

	};
};

function statsInit() {

	var stats = new Stats();
	stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
	document.body.appendChild(stats.dom);

	function animate() {

		stats.begin();

		stats.end();

		requestAnimationFrame(animate);
	}

	requestAnimationFrame(animate);
}

exports.default = Stats;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
/* global THREE */
/**
 * @author mrdoob / http://mrdoob.com
 * @author Mugen87 / https://github.com/Mugen87
 *
 * Based on @tojiro's vr-samples-utils.js
 */

var WEBVR = {

        isAvailable: function isAvailable() {

                console.warn('WEBVR: isAvailable() is being deprecated. Use .checkAvailability() instead.');
                return navigator.getVRDisplays !== undefined;
        },

        checkAvailability: function checkAvailability() {

                return new Promise(function (resolve, reject) {

                        if (navigator.getVRDisplays !== undefined) {

                                navigator.getVRDisplays().then(function (displays) {

                                        if (displays.length === 0) {

                                                reject('WebVR supported, but no VRDisplays found.');
                                        } else {

                                                resolve();
                                        }
                                });
                        } else {

                                reject('Your browser does not support WebVR. See <a href="https://webvr.info">webvr.info</a> for assistance.');
                        }
                });
        },

        getVRDisplay: function getVRDisplay(onDisplay) {

                if ('getVRDisplays' in navigator) {

                        navigator.getVRDisplays().then(function (displays) {

                                onDisplay(displays[0]);
                        });
                }
        },

        getMessage: function getMessage() {

                console.warn('WEBVR: getMessage() is being deprecated. Use .getMessageContainer( message ) instead.');

                var message = void 0;

                if (navigator.getVRDisplays) {

                        navigator.getVRDisplays().then(function (displays) {

                                if (displays.length === 0) message = 'WebVR supported, but no VRDisplays found.';
                        });
                } else {

                        message = 'Your browser does not support WebVR. See <a href="http://webvr.info">webvr.info</a> for assistance.';
                }

                if (message !== undefined) {

                        var container = document.createElement('div');
                        container.style.position = 'absolute';
                        container.style.left = '0';
                        container.style.top = '0';
                        container.style.right = '0';
                        container.style.zIndex = '999';
                        container.align = 'center';

                        var error = document.createElement('div');
                        error.style.fontFamily = 'sans-serif';
                        error.style.fontSize = '16px';
                        error.style.fontStyle = 'normal';
                        error.style.lineHeight = '26px';
                        error.style.backgroundColor = '#fff';
                        error.style.color = '#000';
                        error.style.padding = '10px 20px';
                        error.style.margin = '50px';
                        error.style.display = 'inline-block';
                        error.innerHTML = message;
                        container.appendChild(error);

                        return container;
                }

                return 'no message';
        },

        getMessageContainer: function getMessageContainer(message) {

                var container = document.createElement('div');
                container.style.position = 'absolute';
                container.style.left = '0';
                container.style.top = '0';
                container.style.right = '0';
                container.style.zIndex = '999';
                container.align = 'center';

                var error = document.createElement('div');
                error.style.fontFamily = 'sans-serif';
                error.style.fontSize = '16px';
                error.style.fontStyle = 'normal';
                error.style.lineHeight = '26px';
                error.style.backgroundColor = '#fff';
                error.style.color = '#000';
                error.style.padding = '10px 20px';
                error.style.margin = '50px';
                error.style.display = 'inline-block';
                error.innerHTML = message;
                container.appendChild(error);

                return container;
        },

        getButton: function getButton(display, canvas) {

                if ('VREffect' in THREE && display instanceof THREE.VREffect) {

                        console.error('WebVR.getButton() now expects a VRDisplay.');
                        return document.createElement('button');
                }

                var button = document.createElement('button');
                button.style.position = 'absolute';
                button.style.left = 'calc(50% - 50px)';
                button.style.bottom = '20px';
                button.style.width = '100px';
                button.style.border = '0';
                button.style.padding = '8px';
                button.style.cursor = 'pointer';
                button.style.backgroundColor = '#000';
                button.style.color = '#fff';
                button.style.fontFamily = 'sans-serif';
                button.style.fontSize = '13px';
                button.style.fontStyle = 'normal';
                button.style.textAlign = 'center';
                button.style.zIndex = '999';

                if (display) {

                        button.textContent = 'ENTER VR';
                        button.onclick = function () {

                                display.isPresenting ? display.exitPresent() : display.requestPresent([{ source: canvas }]);
                        };

                        window.addEventListener('vrdisplaypresentchange', function () {

                                button.textContent = display.isPresenting ? 'EXIT VR' : 'ENTER VR';
                        }, false);
                } else {

                        button.textContent = 'NO VR DISPLAY';
                }

                return button;
        }

};

exports.default = WEBVR;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
/* global THREE */

var base = {
        container: new THREE.Object3D(),
        obj: new THREE.Object3D(),
        allWalls: [],
        tile: [23, 19],
        total: function total() {

                return this.tile[0] * this.tile[1];
        },
        block: function block() {

                return {
                        size: [1, 1, 1],
                        color: 0xffffff
                };
        },
        wallSize: function wallSize() {

                return [1, 2, this.block().size[0] / 3];
        },

        mazeStart: [6, 20],
        maze: '| 1---------5---------2' + '| |         |         |' + '| | | 1---2 4-2 | 1-2 |' + '|   | |   |   | | | | |' + '8---6 | | 4-2 4-3 | | |' + '|   | | |   |     |   |' + '| | | 8-7-- 4-----6 --6' + '| |   |           |   |' + '| 8---3 --2 1---2 8-- |' + '| |       | |   | |   |' + '| | --5-- | | | 4-6 1-6' + '| |   |   | | |   | | |' + '| 4-2 | 1-7-6 4-2 | | |' + '|   | | |   |   | | | |' + '8-- | | | | 8-- | | | |' + '|   | | | | |   | | | |' + '| 1-3 | | | | --6 | | |' + '| |   |   |     |     |' + '4-7-- 4---7-----7-----3',
        render: function render() {

                for (var i = 0; i < this.total(); i++) {

                        this.wall(this.maze[i], i);
                }

                this.obj.translateX(-(this.tile[0] / 2));
                this.obj.translateY(this.wallSize()[1] / 2);
                this.obj.translateZ(-(this.tile[1] / 2));
        },
        wall: function wall(str, i) {

                if (str === '|') {

                        this.straitWall(true, i);
                } else if (str === '-') {

                        this.straitWall(false, i);
                } else if (str.match(/[5-8]/g)) {

                        this.teeWall(str, i);
                } else if (str.match(/[1-4]/g)) {

                        this.cornerWall(str, i);
                }
        },
        straitWall: function straitWall(turn, i) {

                var geometry = new THREE.BoxGeometry(this.wallSize()[0], this.wallSize()[1], this.wallSize()[2]),
                    material = new THREE.MeshPhongMaterial({ color: this.block().color, wireframe: false }),
                    WALL = new THREE.Mesh(geometry, material);

                WALL.translateX(i % this.tile[0]);
                WALL.translateZ(Math.floor(i / this.tile[0]));

                if (turn) {

                        WALL.rotation.y = Math.PI / 360 * 180;
                }

                this.allWalls.push(WALL);
                this.obj.add(WALL);
        },
        teeWall: function teeWall(str, i) {

                var num = parseInt(str),
                    subWALL = new THREE.Object3D(),
                    material = new THREE.MeshPhongMaterial({ color: this.block().color, wireframe: false });

                var geometry = new THREE.BoxGeometry(this.wallSize()[0] / 3, this.wallSize()[1], this.wallSize()[2]),
                    WALL = new THREE.Mesh(geometry, material);

                WALL.rotation.y = Math.PI / 360 * 180;
                WALL.translateX(-(this.block().size[0] / 3));
                this.allWalls.push(WALL);
                subWALL.add(WALL);

                geometry = new THREE.BoxGeometry(this.wallSize()[0], this.wallSize()[1], this.wallSize()[2]);
                WALL = new THREE.Mesh(geometry, material);
                WALL.rotation.y = Math.PI / 360;
                this.allWalls.push(WALL);
                subWALL.add(WALL);

                subWALL.translateX(i % this.tile[0]);
                subWALL.translateZ(Math.floor(i / this.tile[0]));
                subWALL.rotation.y = -(Math.PI / 2) * (num - 5);
                this.obj.add(subWALL);
        },
        cornerWall: function cornerWall(str, i) {

                var num = parseInt(str),
                    subWALL = new THREE.Object3D(),
                    material = new THREE.MeshPhongMaterial({ color: this.block().color, wireframe: false, shading: THREE.SmoothShading }),
                    geometry = new THREE.BoxGeometry(this.wallSize()[0] / 3 * 2, this.wallSize()[1], this.wallSize()[2]);

                var WALL = new THREE.Mesh(geometry, material);

                WALL.translateX(this.wallSize()[0] / 6);
                this.allWalls.push(WALL);
                subWALL.add(WALL);

                WALL = new THREE.Mesh(geometry, material);
                WALL.translateZ(this.wallSize()[0] / 6);
                WALL.rotation.y = Math.PI / 360 * 180;
                this.allWalls.push(WALL);
                subWALL.add(WALL);

                subWALL.translateX(i % this.tile[0]);
                subWALL.translateZ(Math.floor(i / this.tile[0]));
                subWALL.rotation.y = -(Math.PI / 2) * (num - 1);
                this.obj.add(subWALL);
        }
};

exports.default = base;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.teleport = exports.rayIntersects = undefined;

var _basics = __webpack_require__(0);

var _maze = __webpack_require__(6);

var _maze2 = _interopRequireDefault(_maze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global THREE */

// import { controller1, controller2 } from './loadViveControllers'
function teleport() {

        var controller = this;

        rayIntersects(controller).then(function (intersectsWith) {

                _maze2.default.container.translateX((0, _basics.numberToOppioite)(intersectsWith[0].point.x));
                _maze2.default.container.translateZ((0, _basics.numberToOppioite)(intersectsWith[0].point.z));
        }).catch(function () {});
}

function rayIntersects(controller) {

        var intersectPromise = new Promise(function (resolve, reject) {

                var tempMatrix = new THREE.Matrix4();

                tempMatrix.identity().extractRotation(controller.matrixWorld);
                _basics.raycaster.ray.origin.setFromMatrixPosition(controller.matrixWorld);
                _basics.raycaster.ray.direction.set(0, 0, -1).applyMatrix4(tempMatrix);

                var intersectsWithBase = _basics.raycaster.intersectObjects(_maze2.default.allWalls),
                    intersectsWithFloor = _basics.raycaster.intersectObject(_maze2.default.container.children[0]);

                if (intersectsWithFloor.length > 0 && intersectsWithBase.length === 0) {

                        resolve(intersectsWithFloor);
                } else {

                        reject(intersectsWithBase);
                }
        });

        return intersectPromise;
}

exports.rayIntersects = rayIntersects;
exports.teleport = teleport;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// script.js